import { SessionTimeoutMonitorProps } from "./SessionTimeoutMonitor.types";
import { useLogoutId, useUrls } from "../../app/Providers/AppContext";
import styles from "./SessionTimeoutMonitor.module.scss";
import { SessionTimeoutWarning } from "../SessionTimeoutWarning";
/**
 * Monitors if the user is idle for a specified period of time and logs the user out if the timeout expires.
 * This is a wrapper for the SessionTimeoutWarning component.
 */
export const SessionTimeoutMonitor = ({
  idleTime,
  timeoutDuration,
}: SessionTimeoutMonitorProps) => {
  const urls = useUrls();
  const logoutId = useLogoutId();

  return (
    <SessionTimeoutWarning
      idleTime={idleTime}
      timeoutDuration={timeoutDuration}
      onTimeoutExpired={logout}
      className={styles.content}
    />
  );

  function logout(): void {
    const logoutUrl = urls.account.logout(window.location.origin, logoutId);
    window.location.assign(logoutUrl);
  }
};
